// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__35T1V","alert":"SettungsInbox_alert__awAPe"};